module.exports = __webpack_public_path__ + "static/img/web_app_dev.723c3ef6.jpg";